import React, { useEffect } from "react";
import "./SourceContainerComponent.css";
import { FontIcon } from "@fluentui/react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

function SourceContainerComponent(props: any) {
  const sourceContent = useSelector((state: RootState) => state.engageGPTState.chatAIMainState.sourceContent);
  console.log(sourceContent);
  return (
    <div className="additional-container detail-container d-flex flex-column col-lg-2 col-12 border-start border-end border-bottom">
      <div className="title d-flex align-items-center justify-content-between">
        <h5>
          <b>Source {sourceContent.ref_id}</b>
        </h5>
        <FontIcon
          iconName="Cancel"
          className="close-icon"
          onClick={() => props.close()}
        />
      </div>
      <div className="body-source-container">
        <div>
          <p>
            <b>Document Name:</b>
          </p>
          <p>{sourceContent.file_name}</p>
        </div>
        <br />
        {/* <div>
          <p>
            <b>Document Path :</b>
          </p>
          <p>{sourceContent.file_path}</p>
        </div>
        <br /> */}
        <div>
          <p>
            <b>Source Title:</b>
          </p>
          <p>{sourceContent.metadata.title}</p>
        </div>
        <div>
          <p>
            <b>Page Number:</b>
          </p>
          <p>{sourceContent.page_number}</p>
        </div>
        <div>
          <p>
            <b>Entities:</b>
          </p>
          <div>
            {sourceContent.metadata.entities.map((entity: any, index: number) => {
              return (
                <p>
                  {index + 1}. {entity}
                </p>
              );
            })}
          </div>
        </div>
        <div>
          <p>
            <b>Keywords:</b>
          </p>
          <div>{sourceContent.metadata.keywords}</div>
        </div>
        <div>
          <p>
            <b>Summary:</b>
          </p>
          <p>{sourceContent.metadata.section_summary}</p>
        </div>
        <div>
          <p>
            <b>Previous Section Summary:</b>
          </p>
          <p>{sourceContent.metadata.prev_section_summary}</p>
        </div>
        <div>
          <p>
            <b>Next Section Summary:</b>
          </p>
          <p>{sourceContent.metadata.next_section_summary}</p>
        </div>
      </div>
    </div>
  );
}

export default SourceContainerComponent;
